import React, { useState, createContext, useMemo, useContext } from 'react'
import { getGeoLang, LocaleCode } from 'services/geo-management'

type LangContextType = {
  currentLang: LocaleCode
  updateCurrentLang: (lang: LocaleCode) => void
}

const startingLang = getGeoLang()

export const LangContext = createContext<LangContextType>({
  currentLang: startingLang,
  updateCurrentLang: () => {},
})

let currLang = startingLang

export const getCurrentLang = () => currLang

type Props = {
  children?: React.ReactNode
}

export const LangContextProvider: React.FC<Props> = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(startingLang)

  const context = useMemo(
    () => ({
      currentLang,
      updateCurrentLang: (lang: LocaleCode) => {
        setCurrentLang(lang)
        currLang = lang
      },
    }),
    [currentLang]
  )

  return <LangContext.Provider value={context}>{children}</LangContext.Provider>
}

export const useLangContext = () => {
  const context = useContext(LangContext)
  if (context === undefined) {
    throw new Error(
      'hook useLangContext must be used within a LangContextProvider'
    )
  }
  return context
}
